import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import getMainDomain from '../utils/getMainDomain';

export default function useToken() {
	const navigate = useNavigate();
	const setToken = (token: string) => {
		const now = Date.now();
		const expireTime = now + 3 * 24 * 60 * 60 * 1000;
		localStorage.setItem('token', token);
		localStorage.setItem('expireTime', JSON.stringify(expireTime));
		document.cookie = `token=${token}; path=/; domain=.${getMainDomain()}; secure; samesite=strict`;
		axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
		navigate('/');
	};

	const token = localStorage.getItem('token');
	return { token, setToken };
}
